import produce from 'immer';
import {
  POST_CREATE_REQUEST,
  POST_DEPOSIT_REQUEST,
  POST_DETAILS_REQUEST,
  POST_EXCEL_DOWNLOAD,
  POST_ITEM_SEARCH_REQUEST,
  POST_LIST_REQUEST,
  POST_REMOVE_REQUEST,
  POST_RESPONSE_MESSAGE,
  POST_USER_SEARCH_REQUEST,
  SET_POST_DETAILS,
  SET_POST_ITEM_LIST,
  SET_POST_LIST,
  SET_POST_PAGINATION,
  SET_POST_USER_LIST,
  SET_TOTAL_COUNT
} from '../../constants/user/postConstants';

const initialState = {

};

const postReducer = (state = initialState, action = {}) => produce(state, draft => {
  switch (action.type) {
    case POST_LIST_REQUEST:
      break;
    case POST_DETAILS_REQUEST:
      break;
    case POST_EXCEL_DOWNLOAD:
      break;
    case POST_ITEM_SEARCH_REQUEST:
      break;
    case POST_USER_SEARCH_REQUEST:
      break;
    case POST_CREATE_REQUEST:
      break;
    case SET_POST_USER_LIST:
      draft.userList = action.list;
      break;
    case SET_POST_ITEM_LIST:
      draft.itemList = action.list;
      break;
    case SET_POST_LIST:
      draft.list = action.list;
      break;
    case SET_POST_DETAILS:
      draft.details = action.list;
      break;
    case SET_TOTAL_COUNT:
      draft.totalCount = action.totalCount;
      break;
    case SET_POST_PAGINATION:
      draft.page = action.page;
      draft.totalCount = action.totalCount;
      draft.attachedPer = action.attachedPer;
      draft.attachedXper = action.attachedXper;
      draft.isAttachedItem = action.isAttachedItem;
      draft.sentAt = action.sentAt;
      draft.expireAt = action.expireAt;
      draft.searchString = action.searchString;
      draft.itemName = action.itemName;
      break;
    case POST_DEPOSIT_REQUEST:
      break;
    case POST_RESPONSE_MESSAGE:
      draft.resultCode = action.resultCode;
      draft.message = action.message;
      break;
    case POST_REMOVE_REQUEST:
      break;
    default:
      break;
  }
});

export default postReducer;
